import type { RouteRecordRaw } from 'vue-router'
import { UserRole } from '@/types/router'

export const userFinanceRoutes: RouteRecordRaw[] = [
  {
    path: 'account-overview',
    name: 'AccountOverview',
    component: () => import('@/views/userCenter/FinancialSummary.vue'),
    meta: {
      title: '账户总览',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Wallet',
      order: 13,
      breadcrumb: true,
      cache: false,
      description: '财务状况总览，包含余额、积分、收益和支出统计',
    },
  },
  {
    path: 'earnings-analysis',
    name: 'EarningsAnalysis',
    component: () => import('@/views/userCenter/FinancialSummary.vue'),
    meta: {
      title: '收益分析',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN], // 允许所有用户查看，但功能受权限限制
      permissions: ['user:finance:view'], // 基础查看权限
      layeredPermissions: {
        view: ['user:finance:view'], // 基础查看权限
        detailedEarnings: ['user:finance:earnings'], // 详细收益权限
        analytics: ['user:finance:analytics'], // 深度分析权限
      },
      permissionGuidance: {
        missingPermission: 'user:finance:earnings',
        upgradeMessage: '成为认证用户即可查看详细收益分析和获得收益',
      },
      icon: 'TrendCharts',
      order: 14,
      breadcrumb: true,
      cache: false,
      description: '平台收益潜力分析，了解认证用户收益机会',
    },
  },
  {
    path: 'transaction-records',
    name: 'TransactionRecords',
    component: () => import('@/views/userCenter/TransactionRecords.vue'),
    meta: {
      title: '交易记录',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Document',
      order: 15,
      breadcrumb: true,
      cache: false,
      description: '完整的交易历史记录，支持筛选、导出和对账功能',
    },
  },
  {
    path: 'payment-withdraw',
    name: 'PaymentWithdraw',
    component: () => import('@/views/userCenter/WithdrawalManagement.vue'),
    meta: {
      title: '充值提现',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN], // 允许所有用户查看，但功能受权限限制
      permissions: ['user:finance:view'], // 基础查看权限
      layeredPermissions: {
        view: ['user:finance:view'], // 查看充值提现界面
        recharge: ['user:finance:recharge'], // 充值权限
        withdraw: ['user:finance:withdraw'], // 提现权限
      },
      permissionGuidance: {
        missingPermission: 'user:finance:withdraw',
        upgradeMessage: '完成认证后即可提现平台收益到个人账户',
      },
      icon: 'Money',
      order: 16,
      breadcrumb: true,
      cache: false,
      description: '资金充值和提现服务，了解平台资金流转机制',
    },
  },
  {
    path: 'vip-purchase',
    name: 'VipPurchase',
    component: () => import('@/views/userCenter/VipPurchase.vue'),
    meta: {
      title: 'VIP购买',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Star',
      order: 17,
      breadcrumb: true,
      cache: false,
      description: '开通/续费VIP会员，享受专属权益',
    },
  },
  {
    path: 'recharge',
    name: 'Recharge',
    component: () => import('@/views/userCenter/Recharge.vue'),
    meta: {
      title: '充值',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Wallet',
      order: 18,
      breadcrumb: true,
      cache: false,
      description: '账户充值，购买积分',
    },
  },
  {
    path: 'deposit',
    name: 'Deposit',
    component: () => import('@/views/userCenter/Deposit.vue'),
    meta: {
      title: '诚信保证金',
      requiresAuth: true,
      roles: [UserRole.USER, UserRole.DESIGNER, UserRole.MANUFACTURER, UserRole.ADMIN],
      icon: 'Money',
      order: 19,
      breadcrumb: true,
      cache: false,
      description: '管理诚信保证金，信用提升',
    },
  },
]
